import { Size } from '@syconium/little-miss-figgy'

import {
  CollectionItemVariantGroupFragment,
  FitModel,
  GetCatalogCollectionQuery,
  Product,
  ProductAsset,
  ProductColor,
  ProductGroup,
  SearchQuery,
  Variant,
} from '../../__generated__/graphql/catalog/graphql'
import { CartStoreLineItem } from '../../lib/adapters/cart-persistence/useCartStore'
import { CartItem } from '../../types/figs'
import { CollectionItemFilterOutput } from '../../types/graphql/collection-view'
import { ProductGroupWithProductAvailability } from '../../types/graphql/product'
import { SearchAutocompleteProduct } from '../../types/graphql/search'

import { sizeChart } from './size-chart'

export type PartialDeep<T> =
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  T extends (...args: any[]) => any
    ? T
    : {
        [P in keyof T]?: PartialDeep<T[P]>
      }

export const sizes = [
  { shorthand: 'XXS', soldOut: true, id: 'XXS' },
  { shorthand: 'XS', soldOut: false, id: 'XS' },
  { shorthand: 'S', soldOut: false, id: 'S' },
  { shorthand: 'M', soldOut: false, id: 'M' },
  { shorthand: 'L', soldOut: false, id: 'L' },
  { shorthand: 'XL', soldOut: true, id: 'XL' },
  { shorthand: '2XL', soldOut: false, id: '2XL' },
] as const satisfies Size[]

const sizeShortHands: string[] = sizes.map(size => size.shorthand)

export const productImages = [
  {
    color: 'Black',
    designFile: null,
    embroideryIconGroup: null,
    embroideryOffsets: undefined,
    fit: 'regular',
    id: 'id-1',
    index: 1,
    kind: 'black',
    source:
      'https://cdn.shopify.com/s/files/1/0139/8942/products/Womens-Casma-Top_black-1.jpg?v=1596835293',
    type: 'ProductImage',
    caption: null,
  },
  {
    color: 'Black',
    designFile: null,
    embroideryIconGroup: null,
    embroideryOffsets: undefined,
    fit: 'regular',
    id: 'id-4',
    index: 2,
    kind: 'black',
    source:
      'https://cdn.shopify.com/s/files/1/0139/8942/products/Womens-Casma-Top_black-2.jpg?v=1596835293',
    type: 'ProductImage',
    caption: null,
  },
  {
    color: 'Ceil Blue',
    designFile: null,
    embroideryIconGroup: null,
    embroideryOffsets: undefined,
    fit: 'tall',
    id: 'id-2',
    index: 2,
    kind: 'flatlay-chest',
    source:
      'https://cdn.shopify.com/s/files/1/0139/8942/products/figs-embroidery-womens_Casma_CB_40b580b6-bf45-440c-8e77-459f9fbedfa1.jpg?v=1596836591',
    type: 'ProductImage',
    caption: null,
  },
  {
    color: 'Graphite',
    designFile: null,
    embroideryIconGroup: null,
    embroideryOffsets: undefined,
    fit: 'petite',
    id: 'id-3',
    index: 3,
    kind: 'ghost',
    source:
      'https://cdn.shopify.com/s/files/1/0139/8942/products/w_FW1100_graphite_transparent.png?v=1596837122',
    type: 'ProductImage',
    caption: null,
  },
] as const satisfies Array<PartialDeep<ProductAsset>>

export const fitModel = {
  description: 'Elizabeth is 5\'2" wearing XS petite',
  height: '5\'2"',
  images: [
    'https://creative.wearfigs.com/m/770250ea17ab707b/webimage-Womens-Catarina-Top_blackS-1',
    'https://creative.wearfigs.com/m/7b2040ad34554aa0/webimage-Womens-Catarina-Top_blackS-2',
    'https://creative.wearfigs.com/m/5ac96a57cb54dcfd/webimage-Womens-Catarina-Top_blackS-3',
    'https://creative.wearfigs.com/m/6869445bec0b6f00/webimage-Womens-Catarina-Top_blackS-4',
    'https://creative.wearfigs.com/m/52fcd01d50f1d2b5/webimage-Womens-Catarina-Top_blackS-5',
  ],
  name: 'Elizabeth',
  pantsSize: 'XS',
  topSize: 'S',
} as const satisfies PartialDeep<FitModel>

const iconBadge = {
  caption: 'pockets',
  icon: { url: 'https://cdn.shopify.com/s/files/1/0139/8942/files/icon-phone.png' },
  iconText: '7',
} as const

export const product = {
  variantGroup: {
    id: 'mock-variant-group-id',
    associatedExclusiveCollectionHandle: null,
  },
  isKit: false,
  availableForSale: true,
  availableFits: [],
  rawAvailableFits: [],
  rtfFeatures: undefined,
  genderCategory: 'women',
  availableSizes: sizeShortHands,
  badgeList: ['baller', 'dank'],
  careInstructions: 'Care instruction directions',
  category: 'Scrub Top',
  collectionBadgeColor: '#500',
  collectionBadgeText: 'Tasty',
  collectionLinks: { nodes: [{ text: 'hey', href: '/some-page' }] },
  color: 'Black',
  colorInfo: {
    availability: 'classics',
    handle: 'black',
    hexCodes: ['#282828'],
    name: 'Black',
    rawName: 'Black',
    swatchUrl: null,
  },
  finalSale: false,
  fit: 'regular',
  fitModel: fitModel,
  fitModelsDescriptions: ["Model 1 is 5'2 and wearing an S / Regular Length"],
  defaultVariant: {
    currencyType: 'USD',
    availableForSale: true,
    color: 'Ceil Blue',
    shopifyId: '5h0p1fy1D',
    sku: '5h0p1fy1D',
    fit: 'petite',
    rawFit: 'petite',
    size: 'small',
    discountPriceExplicitFmt: '',
    priceExplicitFmt: '',
    product: { id: 'asdf' },
    priceDetails: {
      discountPrice: {
        amount: 123,
        base: null,
        currency: '',
      },
      price: {
        amount: 123,
        currency: 'USD',
        base: {
          amount: 123,
          currency: 'USD',
        },
      },
    },
  },
  description: 'Three-Pocket Scrub Top',
  detailImages: [
    'https://d2o3top45uowdm.cloudfront.net/media/final/29cfe9c7-7f12-4f46-bd0f-4d1ffafce91f/webimage-E9025E29-1E9E-4FC0-9E713795322CE8C9.png',
    'https://d2o3top45uowdm.cloudfront.net/media/final/1bf2168e-63b6-4636-b5ae-1d356f5f9082/webimage-8AB4E72F-5C24-4110-9BAB563A4B21C0DE.png',
  ],
  embroidery: null,
  exclusive: false,
  handle: 'some-product-handle',
  iconBadge,
  iconBadgePlacement: 'top left',
  iconList: [
    {
      id: '9',
      label: 'Lauren',
      image:
        'https://cdn.shopify.com/s/files/1/0139/8942/files/Artboard_5_copy_10.svg?1397963845350479501',
      title: 'MODEL IS: XS / 5"8"',
    },
    {
      id: '10',
      label: '3 pockets',
      image:
        'https://cdn.shopify.com/s/files/1/0139/8942/files/Artboard_5_copy_10.svg?1397963845350479501',
      title: '3 pockets',
    },
  ],
  id: 'casma-attribute-id',
  images: {
    nodes: productImages.slice(0, 2),
  },
  noindex: true,
  priceRange: {
    min: 3400,
    max: 3450,
  },
  productGroup: {
    id: 'mock-product-group-id',
    numColors: 3,
    priceRange: null,
    collectionHandle: 'all-scrubs-womens',
    iconBadge,
    style: 'Catarina',
    iconBadgePlacement: 'top left',
    description: 'Three-Pocket Scrub Top',
    rawCategory: 'Scrub Top',
    category: 'Scrub Top',
    colors: [
      {
        availability: 'core',
        handle: 'black',
        hexCodes: ['#282828'],
        name: 'Black',
        rawName: 'Black',
        swatchUrl: null,
      },
      {
        availability: 'limited edition',
        handle: 'ceil-blue',
        hexCodes: ['#5f7fc3'],
        name: 'Ceil Blue',
        rawName: 'Ceil Blue',
        swatchUrl: null,
      },
      {
        availability: 'core',
        handle: 'graphite',
        hexCodes: ['#8d8d97'],
        name: 'Graphite',
        rawName: 'Graphite',
        swatchUrl: null,
      },
    ],
    defaultVariant: {
      fit: 'petite',
      availableForSale: true,
    },
    handle: 'cts-handle',
    fits: ['petite', 'regular'],
    variants: [
      {
        color: 'Ceil Blue',
        shopifyId: '5h0p1fy1D',
        fit: 'petite',
        size: 'small',
        product: { id: 'asdf' },
      },
    ],
    products: [],
    rawFits: ['petite', 'regular'],
    sizes: sizeShortHands,
    sizeChartCG: sizeChart,
    title: "Women's Three Pocket Scrub Top",
    genderCategory: 'womens',
  },
  rawCategory: 'Scrub Top',
  rawFit: 'regular',
  rawMaterials: ['fabric'],
  seoDescription: 'SEO FRIENDLY casma scrub top',
  seoTitle: "SEO FRIENDLY Women's Casma Top",
  shopifyId: 'gid://shopify/Product/69946505130057',
  soldOut: false,
  swPromoEligible: false,
  title: "Women's Casma Three-Pocket Scrub Top",
  videos: {
    nodes: [
      {
        kind: 'catwalk',
        embroideryIconGroup: null,
        embroideryOffsets: undefined,
        designFile: null,
        color: 'Black',
        fit: '',
        id: 'some-video-id',
        index: 1,
        source: 'video.mp4',
        type: 'ProductVideo',
        caption: null,
      },
    ],
  },
  whyWeLove: "It's grrrrreeeat!",
  waitlistable: true,
  variants: [],
} as const satisfies PartialDeep<Product>

export const mockCollectionItemVariantGroup = {
  __typename: 'ProductCatalogVariantGroup',
  id: '9761',
  urlPath: '/collections/atgt-womens/products/womens-rafaela-scrub-top?color=Pulmonary Pink',
  exclusive: true,
  associatedExclusiveCollectionHandle: 'atgt-womens',
  stockState: 'IN_STOCK',
  availability: 'AVAILABLE',
  finalSale: true,
  siteWidePromoEligible: true,
  priceRange: {
    __typename: 'ProductCatalogPriceRange',
    currencyCode: 'USD',
    min: {
      __typename: 'ProductCatalogPrice',
      currencyCode: 'USD',
      amount: 42,
    },
    max: { __typename: 'ProductCatalogPrice', amount: 29.9 },
  },
  compareAtPriceRange: null,
  fits: [
    {
      __typename: 'ProductCatalogFit',
      id: 'regular',
      displayValue: 'regular',
    },
  ],
  description: 'Oversized Scrub Top™',
  primaryCategory: {
    __typename: 'ProductCatalogCategory',
    key: 'SCRUB_TOP',
    id: 'Scrub Top',
  },
  gender: 'women',
  title: 'Rafaela Oversized Scrub Top™',
  plpBadge: null,
  iconBadge: null,
  images: [
    {
      __typename: 'ProductCatalogImage',
      url: 'https://cdn.shopify.com/s/files/1/0139/8942/files/2026_Q1_01_PULMONARY-PINK_RAFAELA_DOMINIQUE_1199.jpg?v=1776371273',
      altText: null,
    },
    {
      __typename: 'ProductCatalogImage',
      url: 'https://cdn.shopify.com/s/files/1/0139/8942/files/2026_Q1_01_PULMONARY-PINK_RAFAELA_DOMINIQUE_1239_750b2d1b-f849-4b50-9c23-463ecfa3bbc8.jpg?v=1778634746',
      altText: null,
    },
  ],
  color: {
    __typename: 'ProductCatalogColor',
    id: 'Pulmonary Pink',
    displayValue: 'Pulmonary Pink',
    hexCodes: ['#B55763'],
    swatchImage: null,
  },
  defaultShopifyProduct: {
    __typename: 'ProductCatalogDefaultShopifyProduct',
    id: 'gid://shopify/Product/7959529259184',
    defaultShopifyVariant: {
      __typename: 'ProductCatalogDefaultShopifyProductVariant',
      id: 'gid://shopify/ProductVariant/44795803828400',
      sku: '1002611A45001:XXS',
    },
  },
  defaultFit: {
    __typename: 'ProductCatalogFit',
    id: 'regular',
    displayValue: 'regular',
  },
  product: {
    __typename: 'ProductCatalogStandardProduct',
    id: '873',
    handle: 'womens-rafaela-scrub-top',
    priceRanges: {
      priceRange: {
        currencyCode: 'USD',
        min: {
          currencyCode: 'USD',
          amount: 42,
        },
        max: {
          amount: 42,
        },
      },
      compareAtPriceRange: null,
    },
    options: {
      __typename: 'ProductCatalogProductOptions',
      colors: [
        {
          __typename: 'ProductCatalogProductColorOption',
          color: {
            __typename: 'ProductCatalogColor',
            id: 'Deep Cranberry',
            hexCodes: ['#62323A'],
            displayValue: 'Deep Cranberry',
            badge: null,
            badgeExpiration: '2026-07-23T00:00-05:00',
            swatchImage: null,
            group: {
              __typename: 'ProductCatalogColorGroup',
              id: 'limited edition',
            },
          },
          compareAtPriceRange: {
            __typename: 'ProductCatalogCompareAtPriceRange',
            min: { __typename: 'ProductCatalogPrice', amount: 42 },
            max: { __typename: 'ProductCatalogPrice', amount: 42 },
            minPercentageOff: 0.38,
            maxPercentageOff: 0.38,
          },
          priceRange: {
            __typename: 'ProductCatalogPriceRange',
            currencyCode: 'USD',
            min: { __typename: 'ProductCatalogPrice', amount: 25.9 },
            max: { __typename: 'ProductCatalogPrice', amount: 25.9 },
          },
          outOfStock: false,
        },
        {
          __typename: 'ProductCatalogProductColorOption',
          color: {
            __typename: 'ProductCatalogColor',
            id: 'Heather Denim',
            hexCodes: ['#585E6F'],
            displayValue: 'Heather Denim',
            badge: null,
            badgeExpiration: '2026-07-23T00:00-05:00',
            swatchImage: null,
            group: {
              __typename: 'ProductCatalogColorGroup',
              id: 'limited edition',
            },
          },
          compareAtPriceRange: {
            __typename: 'ProductCatalogCompareAtPriceRange',
            min: { __typename: 'ProductCatalogPrice', amount: 42 },
            max: { __typename: 'ProductCatalogPrice', amount: 42 },
            minPercentageOff: 0.19,
            maxPercentageOff: 0.19,
          },
          priceRange: {
            __typename: 'ProductCatalogPriceRange',
            currencyCode: 'USD',
            min: { __typename: 'ProductCatalogPrice', amount: 33.9 },
            max: { __typename: 'ProductCatalogPrice', amount: 33.9 },
          },
          outOfStock: false,
        },
        {
          __typename: 'ProductCatalogProductColorOption',
          color: {
            __typename: 'ProductCatalogColor',
            id: 'Heather Indigo',
            hexCodes: ['#5979A2'],
            displayValue: 'Heather Indigo',
            badge: null,
            badgeExpiration: '2026-07-23T00:00-05:00',
            swatchImage: null,
            group: {
              __typename: 'ProductCatalogColorGroup',
              id: 'limited edition',
            },
          },
          compareAtPriceRange: {
            __typename: 'ProductCatalogCompareAtPriceRange',
            min: { __typename: 'ProductCatalogPrice', amount: 42 },
            max: { __typename: 'ProductCatalogPrice', amount: 42 },
            minPercentageOff: 0.19,
            maxPercentageOff: 0.19,
          },
          priceRange: {
            __typename: 'ProductCatalogPriceRange',
            currencyCode: 'USD',
            min: { __typename: 'ProductCatalogPrice', amount: 33.9 },
            max: { __typename: 'ProductCatalogPrice', amount: 33.9 },
          },
          outOfStock: false,
        },
        {
          __typename: 'ProductCatalogProductColorOption',
          color: {
            __typename: 'ProductCatalogColor',
            id: 'Mocha',
            hexCodes: ['#8B5A3F'],
            displayValue: 'Mocha',
            badge: null,
            badgeExpiration: '2026-07-23T00:00-05:00',
            swatchImage: null,
            group: {
              __typename: 'ProductCatalogColorGroup',
              id: 'limited edition',
            },
          },
          compareAtPriceRange: {
            __typename: 'ProductCatalogCompareAtPriceRange',
            min: { __typename: 'ProductCatalogPrice', amount: 42 },
            max: { __typename: 'ProductCatalogPrice', amount: 42 },
            minPercentageOff: 0.29,
            maxPercentageOff: 0.29,
          },
          priceRange: {
            __typename: 'ProductCatalogPriceRange',
            currencyCode: 'USD',
            min: { __typename: 'ProductCatalogPrice', amount: 29.9 },
            max: { __typename: 'ProductCatalogPrice', amount: 29.9 },
          },
          outOfStock: false,
        },
        {
          __typename: 'ProductCatalogProductColorOption',
          color: {
            __typename: 'ProductCatalogColor',
            id: 'Pulmonary Pink',
            hexCodes: ['#B55763'],
            displayValue: 'Pulmonary Pink',
            badge: null,
            badgeExpiration: '2026-07-23T00:00-05:00',
            swatchImage: null,
            group: {
              __typename: 'ProductCatalogColorGroup',
              id: 'limited edition',
            },
          },
          compareAtPriceRange: {
            __typename: 'ProductCatalogCompareAtPriceRange',
            min: { __typename: 'ProductCatalogPrice', amount: 42 },
            max: { __typename: 'ProductCatalogPrice', amount: 42 },
            minPercentageOff: 0.29,
            maxPercentageOff: 0.29,
          },
          priceRange: {
            __typename: 'ProductCatalogPriceRange',
            currencyCode: 'USD',
            min: { __typename: 'ProductCatalogPrice', amount: 29.9 },
            max: { __typename: 'ProductCatalogPrice', amount: 29.9 },
          },
          outOfStock: false,
        },
        {
          __typename: 'ProductCatalogProductColorOption',
          color: {
            __typename: 'ProductCatalogColor',
            id: 'Sapphire',
            hexCodes: ['#2E316B'],
            displayValue: 'Sapphire',
            badge: null,
            badgeExpiration: '2026-07-23T00:00-05:00',
            swatchImage: null,
            group: {
              __typename: 'ProductCatalogColorGroup',
              id: 'limited edition',
            },
          },
          compareAtPriceRange: {
            __typename: 'ProductCatalogCompareAtPriceRange',
            min: { __typename: 'ProductCatalogPrice', amount: 42 },
            max: { __typename: 'ProductCatalogPrice', amount: 42 },
            minPercentageOff: 0.38,
            maxPercentageOff: 0.38,
          },
          priceRange: {
            __typename: 'ProductCatalogPriceRange',
            currencyCode: 'USD',
            min: { __typename: 'ProductCatalogPrice', amount: 25.9 },
            max: { __typename: 'ProductCatalogPrice', amount: 25.9 },
          },
          outOfStock: false,
        },
        {
          __typename: 'ProductCatalogProductColorOption',
          color: {
            __typename: 'ProductCatalogColor',
            id: 'Shocking Pink',
            hexCodes: ['#F9216E'],
            displayValue: 'Shocking Pink',
            badge: null,
            badgeExpiration: '2026-07-23T00:00-05:00',
            swatchImage: null,
            group: {
              __typename: 'ProductCatalogColorGroup',
              id: 'limited edition',
            },
          },
          compareAtPriceRange: {
            __typename: 'ProductCatalogCompareAtPriceRange',
            min: { __typename: 'ProductCatalogPrice', amount: 42 },
            max: { __typename: 'ProductCatalogPrice', amount: 42 },
            minPercentageOff: 0.29,
            maxPercentageOff: 0.29,
          },
          priceRange: {
            __typename: 'ProductCatalogPriceRange',
            currencyCode: 'USD',
            min: { __typename: 'ProductCatalogPrice', amount: 29.9 },
            max: { __typename: 'ProductCatalogPrice', amount: 29.9 },
          },
          outOfStock: false,
        },
        {
          __typename: 'ProductCatalogProductColorOption',
          color: {
            __typename: 'ProductCatalogColor',
            id: 'Spiced Cider',
            hexCodes: ['#B35953'],
            displayValue: 'Spiced Cider',
            badge: null,
            badgeExpiration: '2026-07-23T00:00-05:00',
            swatchImage: null,
            group: {
              __typename: 'ProductCatalogColorGroup',
              id: 'limited edition',
            },
          },
          compareAtPriceRange: {
            __typename: 'ProductCatalogCompareAtPriceRange',
            min: { __typename: 'ProductCatalogPrice', amount: 42 },
            max: { __typename: 'ProductCatalogPrice', amount: 42 },
            minPercentageOff: 0.29,
            maxPercentageOff: 0.29,
          },
          priceRange: {
            __typename: 'ProductCatalogPriceRange',
            currencyCode: 'USD',
            min: { __typename: 'ProductCatalogPrice', amount: 29.9 },
            max: { __typename: 'ProductCatalogPrice', amount: 29.9 },
          },
          outOfStock: false,
        },
        {
          __typename: 'ProductCatalogProductColorOption',
          color: {
            __typename: 'ProductCatalogColor',
            id: 'Spruce',
            hexCodes: ['#4F4A3C'],
            displayValue: 'Spruce',
            badge: null,
            badgeExpiration: '2026-07-23T00:00-05:00',
            swatchImage: null,
            group: {
              __typename: 'ProductCatalogColorGroup',
              id: 'limited edition',
            },
          },
          compareAtPriceRange: {
            __typename: 'ProductCatalogCompareAtPriceRange',
            min: { __typename: 'ProductCatalogPrice', amount: 42 },
            max: { __typename: 'ProductCatalogPrice', amount: 42 },
            minPercentageOff: 0.29,
            maxPercentageOff: 0.29,
          },
          priceRange: {
            __typename: 'ProductCatalogPriceRange',
            currencyCode: 'USD',
            min: { __typename: 'ProductCatalogPrice', amount: 29.9 },
            max: { __typename: 'ProductCatalogPrice', amount: 29.9 },
          },
          outOfStock: false,
        },
        {
          __typename: 'ProductCatalogProductColorOption',
          color: {
            __typename: 'ProductCatalogColor',
            id: 'Surgical Green',
            hexCodes: ['#73CBB1'],
            displayValue: 'Surgical Green',
            badge: null,
            badgeExpiration: '2026-07-23T00:00-05:00',
            swatchImage: null,
            group: {
              __typename: 'ProductCatalogColorGroup',
              id: 'limited edition',
            },
          },
          compareAtPriceRange: {
            __typename: 'ProductCatalogCompareAtPriceRange',
            min: { __typename: 'ProductCatalogPrice', amount: 42 },
            max: { __typename: 'ProductCatalogPrice', amount: 42 },
            minPercentageOff: 0.19,
            maxPercentageOff: 0.19,
          },
          priceRange: {
            __typename: 'ProductCatalogPriceRange',
            currencyCode: 'USD',
            min: { __typename: 'ProductCatalogPrice', amount: 33.9 },
            max: { __typename: 'ProductCatalogPrice', amount: 33.9 },
          },
          outOfStock: false,
        },
        {
          __typename: 'ProductCatalogProductColorOption',
          color: {
            __typename: 'ProductCatalogColor',
            id: 'Ultraberry',
            hexCodes: ['#A25EA5'],
            displayValue: 'Ultraberry',
            badge: null,
            badgeExpiration: '2026-07-23T00:00-05:00',
            swatchImage: null,
            group: {
              __typename: 'ProductCatalogColorGroup',
              id: 'limited edition',
            },
          },
          compareAtPriceRange: {
            __typename: 'ProductCatalogCompareAtPriceRange',
            min: { __typename: 'ProductCatalogPrice', amount: 42 },
            max: { __typename: 'ProductCatalogPrice', amount: 42 },
            minPercentageOff: 0.29,
            maxPercentageOff: 0.29,
          },
          priceRange: {
            __typename: 'ProductCatalogPriceRange',
            currencyCode: 'USD',
            min: { __typename: 'ProductCatalogPrice', amount: 29.9 },
            max: { __typename: 'ProductCatalogPrice', amount: 29.9 },
          },
          outOfStock: false,
        },
        {
          __typename: 'ProductCatalogProductColorOption',
          color: {
            __typename: 'ProductCatalogColor',
            id: 'Walnut',
            hexCodes: ['#613838'],
            displayValue: 'Walnut',
            badge: null,
            badgeExpiration: '2026-07-23T00:00-05:00',
            swatchImage: null,
            group: {
              __typename: 'ProductCatalogColorGroup',
              id: 'limited edition',
            },
          },
          compareAtPriceRange: {
            __typename: 'ProductCatalogCompareAtPriceRange',
            min: { __typename: 'ProductCatalogPrice', amount: 42 },
            max: { __typename: 'ProductCatalogPrice', amount: 42 },
            minPercentageOff: 0.29,
            maxPercentageOff: 0.29,
          },
          priceRange: {
            __typename: 'ProductCatalogPriceRange',
            currencyCode: 'USD',
            min: { __typename: 'ProductCatalogPrice', amount: 29.9 },
            max: { __typename: 'ProductCatalogPrice', amount: 29.9 },
          },
          outOfStock: false,
        },
        {
          __typename: 'ProductCatalogProductColorOption',
          color: {
            __typename: 'ProductCatalogColor',
            id: 'Wild Iris',
            hexCodes: ['#A284C1'],
            displayValue: 'Wild Iris',
            badge: null,
            badgeExpiration: '2026-07-23T00:00-05:00',
            swatchImage: null,
            group: {
              __typename: 'ProductCatalogColorGroup',
              id: 'limited edition',
            },
          },
          compareAtPriceRange: {
            __typename: 'ProductCatalogCompareAtPriceRange',
            min: { __typename: 'ProductCatalogPrice', amount: 42 },
            max: { __typename: 'ProductCatalogPrice', amount: 42 },
            minPercentageOff: 0.19,
            maxPercentageOff: 0.19,
          },
          priceRange: {
            __typename: 'ProductCatalogPriceRange',
            currencyCode: 'USD',
            min: { __typename: 'ProductCatalogPrice', amount: 33.9 },
            max: { __typename: 'ProductCatalogPrice', amount: 33.9 },
          },
          outOfStock: false,
        },
        {
          __typename: 'ProductCatalogProductColorOption',
          color: {
            __typename: 'ProductCatalogColor',
            id: 'Winning Red',
            hexCodes: ['#BA0814'],
            displayValue: 'Winning Red',
            badge: null,
            badgeExpiration: '2026-07-23T00:00-05:00',
            swatchImage: null,
            group: {
              __typename: 'ProductCatalogColorGroup',
              id: 'limited edition',
            },
          },
          compareAtPriceRange: {
            __typename: 'ProductCatalogCompareAtPriceRange',
            min: { __typename: 'ProductCatalogPrice', amount: 42 },
            max: { __typename: 'ProductCatalogPrice', amount: 42 },
            minPercentageOff: 0.19,
            maxPercentageOff: 0.19,
          },
          priceRange: {
            __typename: 'ProductCatalogPriceRange',
            currencyCode: 'USD',
            min: { __typename: 'ProductCatalogPrice', amount: 33.9 },
            max: { __typename: 'ProductCatalogPrice', amount: 33.9 },
          },
          outOfStock: false,
        },
      ],
      colorsTotalCount: 14,
    },
  },
} as const satisfies CollectionItemVariantGroupFragment

const productTestFitsA = {
  ...product,
  color: 'Blue',
  colorInfo: {
    availability: '',
    handle: 'blue',
    hexCodes: ['#0000ff'],
    name: 'Blue',
    rawName: 'Blue',
    swatchUrl: null,
  },
} as const satisfies PartialDeep<Product>

const productTestFitsB = {
  ...product,
  color: 'Blue',
  colorInfo: {
    availability: '',
    handle: 'blue',
    hexCodes: ['#0000ff'],
    name: 'Blue',
    rawName: 'Blue',
    swatchUrl: null,
  },
  fit: 'petite',
  rawFit: 'petite',
} as const satisfies PartialDeep<Product>

export const productColors = [
  {
    accentColor: 'Black',
    availability: 'core',
    handle: 'black',
    hexCodes: ['#282828'],
    name: 'Black',
    rawName: 'Black',
    swatchUrl: '',
  },
  {
    accentColor: 'Ceil Blue',
    availability: 'limited edition',
    handle: 'ceil-blue',
    hexCodes: ['#5f7fc3'],
    name: 'Ceil Blue',
    rawName: 'Ceil Blue',
    swatchUrl: '',
  },
  {
    accentColor: 'Graphite',
    availability: 'core',
    handle: 'graphite',
    hexCodes: ['#8d8d97'],
    name: 'Graphite',
    rawName: 'Graphite',
    swatchUrl: '',
  },
  {
    accentColor: 'Navy',
    availability: 'core',
    handle: 'navy',
    hexCodes: ['#403F6F'],
    name: 'Navy',
    rawName: 'Navy',
    swatchUrl: '',
  },
  {
    accentColor: 'Deep Royal Blue',
    availability: 'limited edition',
    handle: 'deep-royal-blue',
    hexCodes: ['#0F4CC1'],
    name: 'Deep Royal Blue',
    rawName: 'Deep Royal Blue',
    swatchUrl: '',
  },
  {
    accentColor: 'Royal Blue',
    availability: 'core',
    handle: 'royal-blue',
    hexCodes: ['#095BDB'],
    name: 'Royal Blue',
    rawName: 'Royal Blue',
    swatchUrl: '',
  },
  {
    accentColor: 'Burgundy',
    availability: 'core',
    handle: 'burgundy',
    hexCodes: ['#692A2D'],
    name: 'Burgundy',
    rawName: 'Burgundy',
    swatchUrl: '',
  },
  {
    accentColor: 'Alps Blue',
    availability: 'limited edition',
    handle: 'alps-blue',
    hexCodes: ['#0281AE'],
    name: 'Alps Blue',
    rawName: 'Alps Blue',
    swatchUrl: '',
  },
  {
    accentColor: 'Caribbean Blue',
    availability: 'limited edition',
    handle: 'caribbean-blue',
    hexCodes: ['#18455A'],
    name: 'Caribbean Blue',
    rawName: 'Caribbean Blue',
    swatchUrl: '',
  },
  {
    accentColor: 'Charcoal',
    availability: 'limited edition',
    handle: 'charcoal',
    hexCodes: ['#383640'],
    name: 'Charcoal',
    rawName: 'Charcoal',
    swatchUrl: '',
  },
  {
    accentColor: 'Denim',
    availability: 'limited edition',
    handle: 'denim',
    hexCodes: ['#4960B2'],
    name: 'Denim',
    rawName: 'Denim',
    swatchUrl: '',
  },
  {
    accentColor: 'Ice Grey',
    availability: 'limited edition',
    handle: 'ice-grey',
    hexCodes: ['#CACCC7'],
    name: 'Ice Grey',
    rawName: 'Ice Grey',
    swatchUrl: '',
  },
  {
    accentColor: 'Ultra Violet',
    availability: 'limited edition',
    handle: 'ultra-violet',
    hexCodes: ['#7B48A7'],
    name: 'Ultra Violet',
    rawName: 'Ultra Violet',
    swatchUrl: '',
  },
] as const satisfies PartialDeep<ProductColor>[]

const productGroupForVariant = {
  careInstructions: product.careInstructions,
  category: 'Scrub Tops',
  rawCategory: 'Scrub Tops',
  colors: productColors,
  colorGroups: [
    {
      colors: productColors,
      label: 'core',
    },
  ],
  priceRange: undefined,
  defaultVariant: null,
  description: product.description,
  embroiderable: true,
  fits: ['tall', 'petite', 'regular'],
  genderCategory: 'womens',
  handle: 'womens-casma-top',
  iconBadge,
  iconBadgePlacement: 'top right',
  id: 'casma-id',
  products: [product],
  productsForAvailability: [
    {
      availableSizes: ['S', 'M', 'L'],
      colorInfo: {
        rawName: 'Black',
      },
      rawFit: 'petite',
      __typename: 'Product',
      id: '',
      fit: null,
      swPromoEligible: false,
      priceRange: undefined,
      defaultVariant: {
        __typename: undefined,
        price: undefined,
        discountPrice: undefined,
      },
    },
  ],
  rawFits: ['tall', 'petite', 'regular'],
  rawMaterials: product.rawMaterials,
  seoDescription: product.seoDescription,
  seoTitle: product.seoTitle,
  sizeChartCG: product.productGroup.sizeChartCG,
  sizes: sizeShortHands,
  style: 'Casma™',
  title: product.title,
  whyWeLove: product.whyWeLove,
} as const satisfies PartialDeep<ProductGroupWithProductAvailability>

const productGroupForVariantTestFits = {
  ...productGroupForVariant,
  products: [product, productTestFitsA, productTestFitsB],
} as const satisfies PartialDeep<ProductGroup>

export const variant = {
  availableForSale: true,
  category: 'Scrub Tops',
  color: 'Black',
  currencyType: 'USD',
  externalParentId: 'gid://shopify/Product/69746505130050',
  discountPrice: null,
  discountPriceShortFmt: '$38.00',
  discountPriceExplicitFmt: '$38.00 USD',
  genderCategory: 'womens',
  handle: 'some-product-handle',
  image: productImages[0]!,
  images: productImages,
  fit: 'regular',
  rawFit: 'regular',
  price: 48,
  priceShortFmt: '$48.00',
  priceExplicitFmt: '$48.00 USD',
  isLowInventory: false,
  priceDetails: {
    discountPrice: {
      amount: 123,
    },
    price: {
      amount: 123,
      currency: 'USD',
      base: {
        amount: 123,
        currency: 'USD',
      },
    },
  },
  product,
  productGroup: productGroupForVariant,
  rawColor: 'Black',
  shopifyId: 'gid://shopify/ProductVariant/16546505130050',
  size: 'S',
  rawSize: 'S',
  soldOut: false,
  sku: 'T21004TBND:S',
  style: 'casma-three-pocket',
  upc: '194389107570',
} as const satisfies PartialDeep<Variant>

export const productGroup = {
  ...productGroupForVariant,
  collectionHandle: null,
  rtfFeatures: undefined,
  featuredProduct: product,
  defaultVariant: variant,
} as const satisfies PartialDeep<ProductGroup>

export const productGroupTestFits = {
  ...productGroupForVariantTestFits,
  defaultVariant: variant,
} as const satisfies PartialDeep<ProductGroup>

export const collectionFilters = [
  {
    __typename: 'ProductCatalogProductFilter',
    name: 'color',
    displayValue: 'Color',
    values: [
      {
        __typename: 'ProductCatalogProductColorFilterValue',
        state: 'ENABLED',
        value: 'Black',
        displayValue: 'Black',
        sortOrder: 0,
        color: {
          id: 'black',
          hexCodes: ['#282828'],
          swatchImage: null,
        },
      },
      {
        __typename: 'ProductCatalogProductColorFilterValue',
        state: 'ENABLED',
        value: 'Navy',
        displayValue: 'Navy',
        sortOrder: 0,
        color: {
          id: 'navy',
          hexCodes: ['#403F6F'],
          swatchImage: null,
        },
      },
    ],
  },
  {
    __typename: 'ProductCatalogProductFilter',
    name: 'product type',
    displayValue: 'Product Type',
    values: [
      {
        __typename: 'ProductCatalogGenericProductFilterValue',
        state: 'ENABLED',
        value: 'Mask',
        displayValue: 'Mask',
        sortOrder: 0,
      },
      {
        __typename: 'ProductCatalogGenericProductFilterValue',
        state: 'ENABLED',
        value: 'Scrub Jacket',
        displayValue: 'Scrub Jacket',
        sortOrder: 0,
      },
      {
        __typename: 'ProductCatalogGenericProductFilterValue',
        state: 'ENABLED',
        value: 'Scrub Pants',
        displayValue: 'Scrub Pants',
        sortOrder: 0,
      },
      {
        __typename: 'ProductCatalogGenericProductFilterValue',
        state: 'ENABLED',
        value: 'Scrub Top',
        displayValue: 'Scrub Top',
        sortOrder: 0,
      },
    ],
  },
] as const satisfies CollectionItemFilterOutput

export const collection = {
  handle: 'core-collection',
  id: 'collection-id',
  items: {
    filters: collectionFilters,
    nodes: [
      {
        variantGroup: mockCollectionItemVariantGroup,
      },
    ],
    totalCount: 1,
    pageInfo: {
      endCursor: null,
      hasNextPage: false,
    },
  },
} as const satisfies GetCatalogCollectionQuery['productCatalogCollection']

const scrubTopGuid = '50M3-GU1D'

export const embroiderableTopItem: CartItem = {
  image: {
    alt: 'Scrub Top One',
    url: 'https://sandbox.wearfigs.com/scrub-top-one.png',
  },
  key: 'key-2',
  fullPrice: 3800,
  effectivePrice: 3800,
  productGroupHandle: 'embroiderable-top-item',
  shopifyProductId: 'gid://shopify/Product/52046505130059',
  productType: 'Scrub Top One',
  properties: {
    _guid: scrubTopGuid,
  },
  quantity: 1,
  sku: 's-top-1',
  title: 'One Scrub Top',
  variantId: '789012',
  finalSale: false,
  embroiderable: true,
  swPromoEligible: true,
  isLowInventory: false,
  colorId: undefined,
  colorDisplayValue: undefined,
  fitId: undefined,
  fitDisplayValue: undefined,
  sizeId: undefined,
  sizeDisplayValue: undefined,
  shopifyVariantId: '',
  currencyCode: 'USD',
  gender: '',
  categoryId: '',
  availableForSale: true,
  urlPath: '#',
}

export const embroideryItem: CartItem = {
  image: {
    alt: 'Embroidery Options',
    url: 'embroidery-options.png',
  },
  key: 'key-4',
  fullPrice: 1400,
  effectivePrice: 1400,
  productGroupHandle: 'embroidery-item',
  shopifyProductId: 'gid://shopify/Product/86546505130059',
  productType: 'Embroidery',
  properties: {
    _embroidery_version: '1.5',
    _guid: scrubTopGuid,
  },
  quantity: 1,
  sku: 'e-opts',
  title: 'Text Embroidery',
  variantId: '707510',
  finalSale: false,
  embroiderable: false,
  swPromoEligible: true,
  isLowInventory: false,
  colorId: undefined,
  colorDisplayValue: undefined,
  fitId: undefined,
  fitDisplayValue: undefined,
  sizeId: undefined,
  sizeDisplayValue: undefined,
  shopifyVariantId: '',
  currencyCode: 'USD',
  gender: '',
  categoryId: '',
  availableForSale: true,
  urlPath: '#',
}

export const teamsEmbroideryItem: CartItem = {
  image: {
    alt: 'CHLA Embroidery Options',
    url: 'chla-embroidery-options.png',
  },
  key: 'key-84',
  fullPrice: 1600,
  effectivePrice: 1600,
  productGroupHandle: 'teams-embroidery-item',
  shopifyProductId: 'gid://shopify/Product/67542505190059',
  productType: 'Embroidery',
  properties: {},
  quantity: 1,
  sku: 'teams-e-opts',
  title: 'Teams Embroidery',
  variantId: '765443',
  finalSale: false,
  embroiderable: false,
  swPromoEligible: true,
  isLowInventory: false,
  colorId: undefined,
  colorDisplayValue: undefined,
  fitId: undefined,
  fitDisplayValue: undefined,
  sizeId: undefined,
  sizeDisplayValue: undefined,
  shopifyVariantId: '',
  currencyCode: 'USD',
  gender: '',
  categoryId: '',
  availableForSale: true,
  urlPath: '#',
}

const searchFilterMultiValue: SearchQuery['search']['items']['filters'][number] = {
  displayName: 'Color',
  displayType: 'basicColor',
  filterValues: [
    { state: 'ENABLED', value: 'Black' },
    { state: 'ENABLED', value: 'Navy' },
  ],
  key: 'options.color',
}

const searchFilterSingleValue: SearchQuery['search']['items']['filters'][number] = {
  displayName: 'Category',
  displayType: 'basicCheckbox',
  filterValues: [{ state: 'ENABLED', value: 'Scrub Tops' }],
  key: 'options.category',
}

export const searchPageResults = {
  search: {
    suggestions: [{ query: 'scrub tops' }],
    items: {
      colors: [product.colorInfo],
      nodes: [
        {
          productInfo: {
            id: 'mock-variant-id',
            group: mockCollectionItemVariantGroup,
          },
        },
      ],
      filters: [searchFilterMultiValue, searchFilterSingleValue],
      numItems: 1,
      pageInfo: {
        endCursor: '',
        hasNextPage: false,
      },
    },
  },
} as const satisfies SearchQuery

export const searchAutocompleteProduct: SearchAutocompleteProduct = {
  id: '1000',
  soldOut: false,
  defaultShopifyProductId: '1000',
  defaultShopifyVariantId: '1001',
  defaultShopifyVariantSku: 'sku',
  colorKey: 'Mauve',
  handle: 'womens-zamora-jogger-scrub-pants',
  title: "Women's Zamora™ Jogger Scrub Pants",
  url: '/products/womens-zamora-jogger-scrub-pants',
  imageSrc: variant.image.source,
  pricing: {
    priceRange: {
      min: 48,
      max: 48,
    },
    discountPriceRange: {
      min: 39,
      max: 39,
      minPercentageOff: 19,
      maxPercentageOff: 19,
    },
    currencyCode: 'USD',
    unit: 'dollars',
  },
  categoryId: variant.productGroup.category,
  isGiftCard: false,
}

export const embroideryVariant = {
  ...variant,
  productGroup: {
    ...variant.productGroup,
    category: 'Embroidery',
    rawCategory: 'Embroidery',
  },
  images: variant.images.map(o => ({ ...o, embroideryOffsets: {} })),
  category: 'Embroidery',
  discountPrice: null,
  externalParentId: 'gid://shopify/Product/6831800483924',
  sku: 'EMBPLG1015NA:OS',
} as const satisfies PartialDeep<Variant>

const productWithEmbroideryOptions = {
  ...product,
  variantGroup: {
    __typename: 'ProductCatalogVariantGroup',
    id: '4719',
    title: 'Catarina One-Pocket Scrub Top™',
    description: 'One-Pocket Scrub Top™',
    detailImages: [],
    videos: [
      {
        __typename: 'ProductCatalogVideo',
        url: 'https://cdn.shopify.com/s/files/1/0139/8942/files/cwq3_black_catarinatop_1080x1080_200820_dt_final1.mp4?v=1597965616',
        type: 'CATWALK',
      },
      {
        __typename: 'ProductCatalogVideo',
        url: 'https://cdn.shopify.com/videos/c/o/v/1c497331c1d44215845076042f1ec5c8.mp4',
        type: 'UGC',
      },
    ],

    gender: 'women',
    availability: 'AVAILABLE',
    finalSale: false,
    siteWidePromoEligible: true,
    images: [
      {
        url: 'https://cdn.shopify.com/s/files/1/0139/8942/files/Q4_2024_11_BLACK_CATARINA_TAYLOR_0120_3dd54596-7e07-4840-aeb9-9fe2f7b32cb1.jpg?v=1760392802',
        __typename: 'ProductCatalogImage',
      },
      {
        url: 'https://cdn.shopify.com/s/files/1/0139/8942/files/Q4_2024_11_BLACK_CATARINA_TAYLOR_0045_bce0613d-b2a9-45b0-b83f-b49466f9355b.jpg?v=1760392802',
        __typename: 'ProductCatalogImage',
      },
      {
        url: 'https://cdn.shopify.com/s/files/1/0139/8942/files/Q4_2024_11_BLACK_CATARINA_TAYLOR_0137_17f20c97-ba02-4ae7-bf73-c08098315aa4.jpg?v=1760392802',
        __typename: 'ProductCatalogImage',
      },
    ],
    primaryCategory: {
      key: 'SCRUB_TOP',
      id: 'Scrub Top',
      __typename: 'ProductCatalogCategory',
    },

    color: {
      group: {
        id: 'core',
        displayValue: 'core',
        __typename: 'ProductCatalogColorGroup',
      },
      hexCodes: ['#000000'],
      displayValue: 'Black',
      id: 'Black',
      __typename: 'ProductCatalogColor',
    },
    defaultVariant: {
      shopifyProductId: 'gid://shopify/Product/1872585392177',
      __typename: 'ProductCatalogDefaultVariant',
    },
    embroidery: {
      colorRestrictions: [
        {
          key: 'Black',
          __typename: 'ProductCatalogEmbroideryColor',
        },
        {
          key: 'White',
          __typename: 'ProductCatalogEmbroideryColor',
        },
      ],
      fontRestrictions: [
        {
          key: 'Block',
          __typename: 'ProductCatalogEmbroideryFont',
        },
        {
          key: 'Script',
          __typename: 'ProductCatalogEmbroideryFont',
        },
      ],
      flatlay: {
        image: {
          aspectRatio: 1.0,
          url: 'https://cdn.shopify.com/s/files/1/0139/8942/products/catarina-one-pocket-scrub-top-black-embroidery-default.jpg?v=1647896182',
          __typename: 'ProductCatalogImage',
        },
        offsets: [
          {
            placement: {
              location: 'CHEST',
              position: 'LEFT',
              __typename: 'ProductCatalogEmbroideryPlacement',
            },
            rotation: 0.0,
            scale: 0.8,
            x: 0.62,
            y: 0.24,
            __typename: 'ProductCatalogEmbroideryFlatlayOffset',
          },
          {
            placement: {
              location: 'CHEST',
              position: 'RIGHT',
              __typename: 'ProductCatalogEmbroideryPlacement',
            },
            rotation: 0.0,
            scale: 0.8,
            x: 0.39,
            y: 0.3,
            __typename: 'ProductCatalogEmbroideryFlatlayOffset',
          },
          {
            placement: {
              location: 'SLEEVE',
              position: 'LEFT',
              __typename: 'ProductCatalogEmbroideryPlacement',
            },
            rotation: -25.0,
            scale: 1.0,
            x: 0.84,
            y: 0.32,
            __typename: 'ProductCatalogEmbroideryFlatlayOffset',
          },
        ],
        __typename: 'ProductCatalogEmbroideryFlatlay',
      },
      locationFlatlays: [
        {
          location: 'CHEST',
          image: {
            aspectRatio: 1.0,
            url: 'https://cdn.shopify.com/s/files/1/0139/8942/products/catarina-one-pocket-scrub-top-black-embroidery-front-chest.jpg?v=1647896182',
            __typename: 'ProductCatalogImage',
          },
          offsets: [
            {
              placement: {
                location: 'CHEST',
                position: 'LEFT',
                __typename: 'ProductCatalogEmbroideryPlacement',
              },
              rotation: 0.0,
              scale: 1.0,
              x: 0.55,
              y: 0.33,
              __typename: 'ProductCatalogEmbroideryFlatlayOffset',
            },
            {
              placement: {
                location: 'CHEST',
                position: 'RIGHT',
                __typename: 'ProductCatalogEmbroideryPlacement',
              },
              rotation: 0.0,
              scale: 1.0,
              x: 0.15,
              y: 0.4,
              __typename: 'ProductCatalogEmbroideryFlatlayOffset',
            },
            {
              placement: {
                location: 'SLEEVE',
                position: 'LEFT',
                __typename: 'ProductCatalogEmbroideryPlacement',
              },
              rotation: -30.0,
              scale: 1.2,
              x: 0.88,
              y: 0.45,
              __typename: 'ProductCatalogEmbroideryFlatlayOffset',
            },
          ],
          __typename: 'ProductCatalogEmbroideryLocationFlatlay',
        },
        {
          location: 'SLEEVE',
          image: {
            aspectRatio: 1.0,
            url: 'https://cdn.shopify.com/s/files/1/0139/8942/products/catarina-one-pocket-scrub-top-black-embroidery-front-chest.jpg?v=1647896182',
            __typename: 'ProductCatalogImage',
          },
          offsets: [
            {
              placement: {
                location: 'CHEST',
                position: 'LEFT',
                __typename: 'ProductCatalogEmbroideryPlacement',
              },
              rotation: 0.0,
              scale: 1.0,
              x: 0.55,
              y: 0.33,
              __typename: 'ProductCatalogEmbroideryFlatlayOffset',
            },
            {
              placement: {
                location: 'CHEST',
                position: 'RIGHT',
                __typename: 'ProductCatalogEmbroideryPlacement',
              },
              rotation: 0.0,
              scale: 1.0,
              x: 0.15,
              y: 0.4,
              __typename: 'ProductCatalogEmbroideryFlatlayOffset',
            },
            {
              placement: {
                location: 'SLEEVE',
                position: 'LEFT',
                __typename: 'ProductCatalogEmbroideryPlacement',
              },
              rotation: -30.0,
              scale: 1.2,
              x: 0.88,
              y: 0.45,
              __typename: 'ProductCatalogEmbroideryFlatlayOffset',
            },
          ],
          __typename: 'ProductCatalogEmbroideryLocationFlatlay',
        },
      ],
      options: {
        icon: {
          characterLimit: 2,
          key: 'ICON',
          lineLimit: 1,
          placements: [
            {
              location: 'SLEEVE',
              position: 'LEFT',
              __typename: 'ProductCatalogEmbroideryPlacement',
            },
          ],
          __typename: 'ProductCatalogEmbroideryIconOption',
        },
        text: {
          characterLimit: 23,
          key: 'TEXT',
          lineLimit: 2,
          placements: [
            {
              location: 'CHEST',
              position: 'LEFT',
              __typename: 'ProductCatalogEmbroideryPlacement',
            },
            {
              location: 'CHEST',
              position: 'RIGHT',
              __typename: 'ProductCatalogEmbroideryPlacement',
            },
          ],
          __typename: 'ProductCatalogEmbroideryTextOption',
        },
        logo: {
          characterLimit: 0,
          key: 'LOGO',
          lineLimit: 0,
          placements: [
            {
              location: 'CHEST',
              position: 'LEFT',
              __typename: 'ProductCatalogEmbroideryPlacement',
            },
            {
              location: 'CHEST',
              position: 'RIGHT',
              __typename: 'ProductCatalogEmbroideryPlacement',
            },
          ],
          __typename: 'ProductCatalogEmbroideryLogoOption',
        },
        __typename: 'ProductCatalogEmbroideryOptions',
      },
      __typename: 'ProductCatalogEmbroideryConfiguration',
    },
    variant: {
      __typename: 'ProductCatalogVariant',
      id: '45606',
      sku: '1000211A04002:XXS',
      availability: 'AVAILABLE',
      shopifyId: 'gid://shopify/ProductVariant/43345575084208',
      shopifyProductId: 'gid://shopify/Product/1872585392177',
      urlPath: '/products/womens-catarina-scrub-top?color=Black&fit=regular&size=XXS',
      price: {
        amount: 42.0,
        currencyCode: 'USD',
        __typename: 'ProductCatalogPrice',
      },
      compareAtPrice: null,
      size: {
        id: 'XXS',
        displayValue: 'XXS',
        __typename: 'ProductCatalogSize',
      },
      fit: {
        id: 'regular',
        displayValue: 'regular',
        __typename: 'ProductCatalogFit',
      },
    },
  },
} as const satisfies PartialDeep<Product>

export const productGroupWithEmbroideryOptions = {
  ...productGroup,
  products: [productWithEmbroideryOptions],
} as const satisfies PartialDeep<ProductGroup>

export const mockLocalCartItemsCartStoreFormat = [
  {
    sku: variant.sku,
    cartLineId: 'abc',
    bundleProgram: null,
    quantity: 1,
    attributes: [],
  },
  {
    sku: 'SKU-xyz',
    cartLineId: 'xyz',
    bundleProgram: null,
    quantity: 2,
    attributes: [{ key: '_someThing', value: 'value' }],
  },
] as const satisfies Omit<CartStoreLineItem, 'cost' | 'discounts'>[]

export const filterableFits: string[] = ['regular', 'petite', 'tall']
